<template>
    <div
        class="step-content-wrapper"
        :class="{ 'dialog-mode': mode === 'dialog' }"
    >
        <!--  NECESITAS UNA FACTURA? -->
        <v-card variant="flat" color="transparent">
            <v-card-title class="text-text"
                >{{ $t("facturacion.requiere-factura") }}
            </v-card-title>
            <!-- RADIO FACTURA -->
            <v-card-text>
                <form-group :validator="$v.facturar.facturacion">
                    <template #default="{ attrs }">
                        <v-radio-group
                            v-model="facturar.facturacion"
                            v-bind="attrs"
                            inline
                            @update:model-value="requiereFactura"
                        >
                            <v-radio :value="1" color="primary">
                                <template v-slot:label>
                                    <div
                                        :class="[
                                            facturar.facturacion === 1
                                                ? 'text-text'
                                                : 'text-grey',
                                        ]"
                                    >
                                        {{ $t("radio-si") }}
                                    </div>
                                </template>
                            </v-radio>
                            <v-radio :value="0" color="primary">
                                <template v-slot:label>
                                    <div
                                        :class="[
                                            facturar.facturacion === 0
                                                ? 'text-text'
                                                : 'text-grey',
                                        ]"
                                    >
                                        {{ $t("radio-no") }}
                                    </div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </template>
                </form-group>
            </v-card-text>
        </v-card>
        <v-divider v-if="facturar.facturacion == 1"></v-divider>
        <!-- SELECT RFC Y BOTÓN NUEVO -->
        <v-card
            variant="flat"
            color="transparente"
            v-if="facturar.facturacion == 1"
            class="mb-4"
        >
            <v-card-title class="text-body-1 text-text font-weight-bold"
                >{{ $t("facturacion.datos-fiscales") }}
                <div class="text-wrap text-textDarken text-body-2 mb-2">
                    {{ $t("facturacion.subtitulo") }}
                </div>
            </v-card-title>
            <!-- SELECCIÓN RFC Y BOTÓN NUEVO -->
            <v-card-text class="d-lg-flex d-md-flex d-sm-flex pa-4 pb-0">
                <form-group
                    :validator="$v.facturar.DatoFiscalId"
                    class="flex-grow-1"
                >
                    <template #default="{ attrs }">
                        <v-select
                            v-model="facturar.DatoFiscalId"
                            v-bind="attrs"
                            :items="datosFiscalesList"
                            item-title="razon_social"
                            item-value="id"
                            :label="$t('seleccione')"
                            variant="outlined"
                            density="compact"
                            @update:model-value="seleccionarRFC"
                        >
                            <template v-slot:no-data>
                                <div class="text-body-2 px-3">
                                    {{ $t("no-datos") }}
                                </div>
                            </template>
                        </v-select>
                    </template>
                </form-group>
                <v-btn
                    variant="flat"
                    color="primaryLight"
                    @click="abrirDialogoNuevoRFC"
                    class="ml-4 custom-hover text-primary flex-grow-0 flex-shrink-0"
                >
                    <v-icon start color="primary"> mdi-plus </v-icon>
                    {{ $t("boton-nuevo") }}
                </v-btn>
            </v-card-text>
        </v-card>
        <v-divider
            class="my-2"
            v-if="facturar.DatoFiscalId != null"
        ></v-divider>
        <!-- DESGLOSE RFC SELECCIONADO -->
        <v-card
            variant="flat"
            color="transparent"
            v-if="
                facturar.DatoFiscalId != null &&
                Object.keys(ordenFacturar).length > 0
            "
        >
            <v-card-text>
                <v-row>
                    <v-col cols="12" lg="3" md="4" sm="12">
                        <v-text-field
                            :model-value="$t('facturacion.cliente.1')"
                            :label="$t('facturacion.cliente.residencia')"
                            variant="outlined"
                            density="compact"
                            readonly
                            v-if="ordenFacturar.tipo === 1"
                        ></v-text-field>
                        <v-text-field
                            :model-value="$t('facturacion.cliente.2')"
                            :label="$t('facturacion.cliente.residencia')"
                            variant="outlined"
                            density="compact"
                            readonly
                            v-else
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="9" md="8" sm="12">
                        <v-text-field
                            :model-value="ordenFacturar.razon_social"
                            :label="$t('facturacion.razon-social')"
                            variant="outlined"
                            density="compact"
                            readonly
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="ordenFacturar.tipo === 1">
                    <v-col cols="12" lg="2" md="3" sm="12">
                        <v-text-field
                            :model-value="ordenFacturar.rfc"
                            :label="$t('facturacion.rfc')"
                            variant="outlined"
                            density="compact"
                            readonly
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="2" md="2" sm="12">
                        <v-text-field
                            :model-value="ordenFacturar.codigo_postal"
                            :label="$t('facturacion.codigo-postal')"
                            variant="outlined"
                            density="compact"
                            readonly
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4" md="4" sm="12">
                        <v-text-field
                            :model-value="
                                ordenFacturar.regimen_fiscal?.nombre || ''
                            "
                            :label="$t('facturacion.regimen')"
                            variant="outlined"
                            density="compact"
                            readonly
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4" md="3" sm="12">
                        <v-text-field
                            :model-value="ordenFacturar.uso_cfdi?.nombre || ''"
                            :label="$t('facturacion.uso-cfdi')"
                            variant="outlined"
                            density="compact"
                            readonly
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- BOTONES FACTURACION -->
        <!-- Solo mostrar en modo stepper -->
        <v-card v-if="mode === 'stepper'" variant="flat" class="mt-4">
            <v-card-actions class="d-flex flex-row justify-center">
                <v-btn
                    variant="outlined"
                    color="primary"
                    @click="regresar"
                    class="mx-2"
                >
                    {{ $t("boton-regresar") }}
                </v-btn>
                <v-btn
                    color="primary"
                    variant="flat"
                    @click="validarRequireFactura"
                    class="mx-2"
                >
                    {{ $t("boton-continuar") }}
                </v-btn>
            </v-card-actions></v-card
        >
        <!-- Botón de confirmar para modo dialog -->
        <v-card
            v-if="mode === 'dialog'"
            variant="flat"
            class="mt-4"
            color="transparent"
        >
            <v-card-actions class="d-flex flex-row justify-center">
                <v-btn
                    variant="outlined"
                    color="primary"
                    @click="cancelarDialog"
                    class="mx-2"
                >
                    {{ $t("boton-cancelar") }}
                </v-btn>
                <v-btn
                    color="primary"
                    variant="flat"
                    @click="confirmarFacturacion"
                    class="mx-2"
                >
                    {{ $t("boton-guardar") }}
                </v-btn>
            </v-card-actions></v-card
        >

        <!-- DIALOGO FORMULARIO NUEVO RFC -->
        <NuevoDatoFiscal
            v-model="dialogoNuevoRFC"
            :stand-id="stand.id"
            :forma="forma"
            :orden="orden"
            @saved="handleTaxIdCreated"
        />
    </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import { router } from "@inertiajs/vue3";
import axios from "axios";
import NuevoDatoFiscal from "./NuevoDatoFiscal.vue";

const { t } = useI18n();

const props = defineProps({
    forma: Object,
    stand: Object,
    orden: Object,
    datos_fiscales: Array,
    mode: {
        type: String,
        default: "stepper",
        validator: (value) => ["stepper", "dialog"].includes(value),
    },
});

const emit = defineEmits(["accionStepper", "completed", "cancel"]);

const facturar = ref({
    facturacion: props.orden?.facturacion ?? null,
    DatoFiscalId: props.orden?.dato_fiscal_id ?? null,
});
// Inicializar ordenFacturar y asegurarse de que el tipo sea un número
const initialDatoFiscal =
    props.orden?.dato_fiscal_id != null ? props.orden.dato_fiscal : {};
if (initialDatoFiscal && initialDatoFiscal.tipo !== undefined) {
    initialDatoFiscal.tipo = parseInt(initialDatoFiscal.tipo, 10);
}
const ordenFacturar = ref(initialDatoFiscal);
const dialogoNuevoRFC = ref(false);
const datosFiscalesList = ref([...props.datos_fiscales]);

// Watch for changes in datos_fiscales prop (useful in dialog mode)
watch(
    () => props.datos_fiscales,
    (newDatosFiscales) => {
        if (newDatosFiscales && newDatosFiscales.length > 0) {
            datosFiscalesList.value = [...newDatosFiscales];
        }
    },
    { deep: true }
);

const rules = computed(() => ({
    facturar: {
        facturacion: {
            required: helpers.withMessage(
                () => t("validations.required"),
                required
            ),
        },
        DatoFiscalId: {
            required: helpers.withMessage(
                () => t("validations.required"),
                required
            ),
        },
    },
}));

const $v = useVuelidate(rules, { facturar });

function requiereFactura() {
    $v.value.$reset();

    // Determine which route to use based on forma type
    const formaUrl = props.forma?.url_formulario || "";
    const isFormaDinamicaA = formaUrl.includes("forma-dinamica-a");
    const formaParametros =
        props.forma?.parametros || props.forma?.clave || "default";

    const routeName = isFormaDinamicaA
        ? "forma-dinamica-a.facturacion"
        : "forma-dinamica-b.facturacion";

    const routeParams = isFormaDinamicaA
        ? {
              stand: props.stand.id,
              forma: formaParametros,
              orden: props.orden.id,
          }
        : {
              stand: props.stand.id,
              forma: formaParametros,
              orden: props.orden.id,
          };

    // In dialog mode, use axios directly to avoid redirect issues
    if (props.mode === "dialog") {
        axios
            .post(route(routeName, routeParams), {
                facturacion: facturar.value.facturacion,
                orden_id: props.orden?.id,
            })
            .then(() => {
                // Update local state
                facturar.value.facturacion = facturar.value.facturacion;
                // The order will be refreshed when the dialog closes
            })
            .catch((error) => {
                console.error("Error updating facturacion:", error);
            });
    } else {
        // In stepper mode, use Inertia router
        router.post(
            route(routeName, routeParams),
            {
                facturacion: facturar.value.facturacion,
                orden_id: props.orden?.id,
            },
            {
                onSuccess: (page) => {
                    router.reload({
                        only: ["orden", "datos_fiscales"],
                        onSuccess: () => {},
                    });
                    facturar.value.facturacion = props.orden.facturacion;
                    facturar.value.DatoFiscalId = props.orden.dato_fiscal_id;
                },
            }
        );
    }
}

function abrirDialogoNuevoRFC() {
    dialogoNuevoRFC.value = true;
}

function seleccionarRFC() {
    // Si no hay selección, limpiar
    if (!facturar.value.DatoFiscalId) {
        ordenFacturar.value = {};
        return;
    }

    // Determine which route to use based on forma type
    const formaUrl = props.forma?.url_formulario || "";
    const isFormaDinamicaA = formaUrl.includes("forma-dinamica-a");
    const formaParametros =
        props.forma?.parametros || props.forma?.clave || "default";

    const routeName = isFormaDinamicaA
        ? "forma-dinamica-a.dato-fiscal"
        : "forma-dinamica-b.dato-fiscal";

    const routeParams = isFormaDinamicaA
        ? {
              stand: props.stand.id,
              forma: formaParametros,
              orden: props.orden.id,
          }
        : {
              stand: props.stand.id,
              forma: formaParametros,
              orden: props.orden.id,
          };

    // Hacer petición al backend para obtener el dato fiscal completo
    // Esta petición también actualiza la orden con el dato_fiscal_id
    axios
        .post(route(routeName, routeParams), {
            dato_fiscal_id: facturar.value.DatoFiscalId,
            orden_id: props.orden?.id, // Include orden_id for ServiceUtilitiesTab context
        })
        .then((response) => {
            const datoFiscal = response.data.dato_fiscal;
            // Asegurarse de que el tipo sea un número (puede venir como string desde el backend)
            if (datoFiscal && datoFiscal.tipo !== undefined) {
                datoFiscal.tipo = parseInt(datoFiscal.tipo, 10);
            }
            ordenFacturar.value = datoFiscal;
            facturar.value.facturacion = response.data.facturacion;
            facturar.value.DatoFiscalId = response.data.dato_fiscal_id;

            // En modo dialog, la orden ya se actualizó en el backend
            // No necesitamos hacer nada adicional
        })
        .catch((error) => {
            console.error("Error al cargar dato fiscal:", error);
        });
}

async function handleTaxIdCreated(createdDatoFiscal) {
    if (createdDatoFiscal && createdDatoFiscal.id) {
        // En modo dialog, recargar la lista completa de datos fiscales desde el endpoint
        if (props.mode === "dialog") {
            try {
                const response = await axios.get(
                    route("datos-fiscales.list", { stand: props.stand.id })
                );
                // Asegurarse de que todos los tipos sean números
                const datosFiscales = response.data.map((df) => {
                    if (df.tipo !== undefined) {
                        df.tipo = parseInt(df.tipo, 10);
                    }
                    return df;
                });
                datosFiscalesList.value = datosFiscales;
            } catch (error) {
                console.error("Error reloading datos fiscales:", error);
                // Fallback: agregar el nuevo dato fiscal a la lista si no se pudo recargar
                const exists = datosFiscalesList.value.find(
                    (df) => df.id === createdDatoFiscal.id
                );
                if (!exists) {
                    // Asegurarse de que el tipo sea un número antes de agregarlo
                    if (createdDatoFiscal.tipo !== undefined) {
                        createdDatoFiscal.tipo = parseInt(
                            createdDatoFiscal.tipo,
                            10
                        );
                    }
                    datosFiscalesList.value.push(createdDatoFiscal);
                }
            }
        } else {
            // En modo stepper, Inertia ya habrá recargado la página
            // Solo necesitamos actualizar la lista local
            const exists = datosFiscalesList.value.find(
                (df) => df.id === createdDatoFiscal.id
            );
            if (!exists) {
                datosFiscalesList.value.push(createdDatoFiscal);
            }
        }

        // Auto-seleccionar el dato fiscal recién creado
        facturar.value.DatoFiscalId = createdDatoFiscal.id;

        // Asegurarse de que el tipo sea un número (puede venir como string desde el backend)
        if (createdDatoFiscal.tipo !== undefined) {
            createdDatoFiscal.tipo = parseInt(createdDatoFiscal.tipo, 10);
        }

        // Si el dato fiscal tiene las relaciones cargadas, usarlo directamente
        // De lo contrario, hacer una petición para obtener el dato fiscal completo
        if (createdDatoFiscal.regimen_fiscal && createdDatoFiscal.uso_cfdi) {
            ordenFacturar.value = createdDatoFiscal;
        } else {
            // Hacer petición para obtener el dato fiscal completo con sus relaciones
            seleccionarRFC();
        }
    }
}

function validarRequireFactura() {
    $v.value.facturar.$touch();
    if ($v.value.facturar.facturacion.$invalid) {
        return;
    }
    if (facturar.value.facturacion == 1) {
        if ($v.value.facturar.DatoFiscalId.$invalid) {
            return;
        }
    }
    // Emit accionStepper with action 4 to go to next step (payment)
    emit("accionStepper", 4);
}

function regresar() {
    // Emit accionStepper with action 3 to go to previous step
    emit("accionStepper", 3);
}

// Funciones para modo dialog
async function confirmarFacturacion() {
    $v.value.facturar.$touch();

    if ($v.value.facturar.facturacion.$invalid) {
        return;
    }

    if (facturar.value.facturacion == 1) {
        if ($v.value.facturar.DatoFiscalId.$invalid) {
            return;
        }

        // Si hay un dato fiscal seleccionado, asegurarnos de que se actualice en el backend
        // Esto es importante porque seleccionarRFC() solo se llama cuando cambia la selección
        // Si el usuario selecciona y luego presiona guardar sin cambiar, necesitamos actualizar
        if (facturar.value.DatoFiscalId) {
            // Verificar si ya tenemos los datos cargados y coinciden
            const hasDataLoaded =
                ordenFacturar.value &&
                Object.keys(ordenFacturar.value).length > 0 &&
                ordenFacturar.value.id === facturar.value.DatoFiscalId;

            if (!hasDataLoaded) {
                // Si no tenemos los datos cargados o no coinciden, cargarlos y actualizar
                // Convertir seleccionarRFC a async y esperar a que complete
                await new Promise((resolve, reject) => {
                    const formaUrl = props.forma?.url_formulario || "";
                    const isFormaDinamicaA =
                        formaUrl.includes("forma-dinamica-a");
                    const formaParametros =
                        props.forma?.parametros ||
                        props.forma?.clave ||
                        "default";

                    const routeName = isFormaDinamicaA
                        ? "forma-dinamica-a.dato-fiscal"
                        : "forma-dinamica-b.dato-fiscal";

                    const routeParams = isFormaDinamicaA
                        ? {
                              stand: props.stand.id,
                              forma: formaParametros,
                              orden: props.orden.id,
                          }
                        : {
                              stand: props.stand.id,
                              forma: formaParametros,
                              orden: props.orden.id,
                          };

                    axios
                        .post(route(routeName, routeParams), {
                            dato_fiscal_id: facturar.value.DatoFiscalId,
                            orden_id: props.orden?.id,
                        })
                        .then((response) => {
                            ordenFacturar.value = response.data.dato_fiscal;
                            facturar.value.facturacion =
                                response.data.facturacion;
                            facturar.value.DatoFiscalId =
                                response.data.dato_fiscal_id;
                            resolve();
                        })
                        .catch((error) => {
                            console.error(
                                "Error al actualizar dato fiscal:",
                                error
                            );
                            reject(error);
                        });
                });
            }
        }
    }

    // Si llegamos aquí, la validación pasó
    // La actualización de facturacion ya se hizo en requiereFactura()
    // Si se seleccionó un dato fiscal, la orden ya se actualizó (ya sea en seleccionarRFC() o arriba)
    // Solo necesitamos emitir el evento de completado
    emit("completed", {
        facturacion: facturar.value.facturacion,
        dato_fiscal_id: facturar.value.DatoFiscalId,
    });
}

function cancelarDialog() {
    emit("cancel");
}
</script>

<style scoped>
.step-content-wrapper {
    max-width: 75%;
    margin: 0 auto;
}

/* Estilos para modo dialog */
.step-content-wrapper.dialog-mode {
    max-width: 100%;
    margin: 0;
    padding: 0;
}

@media (max-width: 960px) {
    .step-content-wrapper {
        max-width: 100%;
    }
}

.custom-hover:hover {
    background-color: rgba(var(--v-theme-primary), 0.1);
}
</style>
